import React, {useEffect, useState} from "react";
import "./SendMessage.css";
import {getConversationMessages} from "../../../../../../service-layer/ChatService";
import {useLocation, useNavigate} from "react-router-dom";
import {getStaffId} from "../../../../../../axios/CurrentMedicalStaffManager";
import ChatWindow from "../ChatWindow/ChatWindow";
import LogoutModal from "../../../../../components/logout-moal/LogoutModal";
import {useTranslation} from "react-i18next";

const SendMessage = () => {
    const [messages, setMessages] = useState([
        {messagePayload: "", messageTimestamp: ""},
    ]);
    const [newMessage, setNewMessage] = useState("");
    const location = useLocation();
    const [messageSent, setMessageSent] = useState(false)
    const {t} = useTranslation();
    const {medicalStaffId, patientId, patientData} = location.state;
    const [showLogoutModal, setShowLogoutModal] = useState(false);

    const handleConfirm = () => {
        localStorage.removeItem("auth_token");
        localStorage.removeItem("name");
        localStorage.removeItem("surname");
        localStorage.removeItem("authority");
        setShowLogoutModal(false);
        navigate("/");
    };


    const navigate = useNavigate();
    useEffect(() => {
        if (window.localStorage.getItem("auth_token") === null) navigate("/login");
    }, [navigate]);

    useEffect(() => {
        // axios api call
        if (messageSent)
            getConversationMessages(patientId, getStaffId()).then((response) => {
                if (response) {
                    let resp = response.map(m => {
                        return {...m, messageDateTime: new Date(m.messageTimestamp)}
                    })
                    console.log("RESP", resp.sort((a, b) => a.messageDateTime - b.messageDateTime))
                    setMessages(resp);
                    setMessageSent(false)
                }

            }).catch(() => {
                setShowLogoutModal(true);
            });
    }, [messageSent]);

    useEffect(() => {
        getConversationMessages(patientId, getStaffId()).then((response) => {
            if (response) {
                let resp = response.map(m => {
                    return {...m, messageDateTime: new Date(m.messageTimestamp)}
                })
                console.log("RESP", resp.sort((a, b) => a.messageDateTime - b.messageDateTime))
                setMessages(resp);
            }
        }).catch(() => {
            setShowLogoutModal(true);
        });
    }, [])


    const token = window.localStorage.getItem("auth_token");

    // Extract patient information
    const patient = patientData && patientData.length > 0 ? patientData[0] : null;


    return (
        <>
            {token && (
                <div style={{height: "100%"}}>
                    <div className="center-div-container">
                        <div className="app">
                            <div className="chat-container">
                                {/* Patient Header */}
                                {patient && (
                                    <div className="patient-header">
                                        <div className="patient-info">
                                            <div className="patient-name">
                                                {patient.name} {patient.surname}
                                            </div>
                                            <div className="patient-details">
                                                {t("fiscalCode")}: {patient.fiscalCode} | {t("email")}: {patient.email}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <ChatWindow
                                    chat={messages}
                                    newMessage={newMessage}
                                    setNewMessage={setNewMessage}
                                    setMessageSent={setMessageSent}
                                    medicalStaffId={medicalStaffId}
                                    patientId={patientId}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {!token && <div className="login-container"></div>}
            <LogoutModal
                show={showLogoutModal}
                handleConfirm={handleConfirm}
                handleClose={handleConfirm}
                title={t("login")}
                message={t("session_expired_please_login_again")}
                tag={"Login"}
            />
        </>

    );
};

export default SendMessage;
